import { LOCALE_MAP, LEGACY_MAP } from './constants';

export const normalizeLocale = (locale: string): string => LOCALE_MAP[locale] || LEGACY_MAP[locale] || locale;
